import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
    LayoutDashboard, BookOpen, TrendingUp, MessageSquare, Star,
    Home, Library, GraduationCap, Route, Trophy, Award, ScrollText, Bookmark,
    Settings, Users, User, HelpCircle, Layers, Brain, FlaskConical, BarChart2
} from 'lucide-react';

const teacherLinks = [
    { to: '/teacher/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { to: '/teacher/courses', label: 'Kurslarim', icon: BookOpen },
    { to: '/teacher/analytics', label: 'Analitika', icon: TrendingUp },
    { to: '/teacher/advanced-analytics', label: 'Kengaytirilgan analitika', icon: BarChart2 },
    { to: '/teacher/experiment', label: 'Eksperiment', icon: FlaskConical },
    { to: '/teacher/reviews', label: 'Sharhlar', icon: Star },
    { to: '/discussions', label: 'Muhokamalar', icon: MessageSquare },
];

const studentLinks = [
    { to: '/student/dashboard', label: 'Dashboard', icon: Home },
    { to: '/courses', label: 'Kurslar katalogi', icon: Library },
    { to: '/student/my-courses', label: 'Mening kurslarim', icon: BookOpen },
    { to: '/learning-paths', label: "O'quv yo'llari", icon: Route },
    { to: '/leaderboard', label: 'Reyting', icon: Trophy },
    { to: '/achievements', label: 'Yutuqlar', icon: Award },
    { to: '/certificates', label: 'Sertifikatlar', icon: ScrollText },
    { to: '/bookmarks', label: 'Saqlanganlar', icon: Bookmark },
];

const adminLinks = [
    { to: '/admin/dashboard', label: 'Dashboard', icon: Settings },
    { to: '/admin/users', label: 'Foydalanuvchilar', icon: Users },
    { to: '/admin/courses', label: 'Kurslar', icon: BookOpen },
    { to: '/admin/categories', label: 'Kategoriyalar', icon: Layers },
    { to: '/admin/learning-paths', label: "O'quv yo'llari", icon: Route },
    { to: '/admin/ai-settings', label: 'AI Sozlamalari', icon: Brain },
];

export default function Sidebar() {
    const { user } = useAuth();
    const links = user?.role === 'admin' ? adminLinks : user?.role === 'teacher' ? teacherLinks : studentLinks;

    return (
        <aside className="fixed left-0 top-0 h-full w-64 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 z-40 flex flex-col">
            <div className="px-6 py-5 border-b border-gray-100 dark:border-gray-700">
                <div className="flex items-center gap-3">
                    <div className="w-9 h-9 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">S</div>
                    <div>
                        <h1 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">SmartEduLab</h1>
                        <p className="text-[10px] text-gray-400 -mt-0.5">Elektron ta'lim platformasi</p>
                    </div>
                </div>
            </div>

            <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
                {links.map((link) => (
                    <NavLink
                        key={link.to}
                        to={link.to}
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all ${
                                isActive
                                    ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 shadow-sm'
                                    : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-200'
                            }`
                        }
                    >
                        <link.icon className="w-[18px] h-[18px]" />
                        <span>{link.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="px-3 py-4 border-t border-gray-100 dark:border-gray-700 space-y-1">
                <NavLink to="/profile" className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all ${isActive ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300' : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800'}`}>
                    <User className="w-[18px] h-[18px]" /><span>Profil</span>
                </NavLink>
                <NavLink to="/guide" className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800">
                    <HelpCircle className="w-[18px] h-[18px]" /><span>Qo'llanma</span>
                </NavLink>
            </div>
        </aside>
    );
}